import { useSEMRushWebsiteTrafficCRUDActions } from '@mm/state/actions/SEMRushWebsiteTrafficActions';
import userGeodataCRUDActions from '@mm/state/actions/UserGeodataCRUDActions';
import { useWebsiteReportSummaryActions } from '@mm/state/actions/WebsiteReportSummaryActions';
import { SEMRushWebsiteTrafficModel } from '@mm/state/model/SEMRushWebsiteTrafficModel';
import { UserGeodataModel } from '@mm/state/model/UserGeodataModel';
import { StoreState } from '@mm/state/store-interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { TRAFFIC_SUM_TRESHOLD } from './constants';

export const useGetWebsiteTraffic = ({
  onTrafficAbsent,
  onNonUSTraffic,
  setShowPaidTrafficROI,
}: {
  onTrafficAbsent?: () => void;
  onNonUSTraffic?: () => void;
  setShowPaidTrafficROI?: (yes: boolean) => void;
}) => {
  const {
    retriveTotalsByDomain,
    retriveMonthlyByDomain,
    retriveCompetitorsByDomain,
    retriveTopLandingsByDomain,
    retriveSummaryByDomain,
  } = useSEMRushWebsiteTrafficCRUDActions();
  const {
    setTrafficTotals,
    setTrafficMonthly,
    setTrafficLoaded,
    setTrafficBusy,
    setCompetitors,
    setTopLiandings,
    setWebsiteSummary,
  } = useWebsiteReportSummaryActions();

  const dispatch: Dispatch<StoreState> = useDispatch();
  const userGeodata = useSelector((state: StoreState) => state.userGeodata);

  const retrieveTotals = async (domain: string) => {
    let totals: SEMRushWebsiteTrafficModel | undefined;

    setTrafficBusy(true);

    const data = Object.keys(userGeodata).length
      ? userGeodata
      : await dispatch(userGeodataCRUDActions.getData());

    try {
      totals = await retriveTotalsByDomain(
        domain,
        data?.IPv4,
        data?.country_code,
      );
    } catch (e) {}
    if (totals) {
      setTrafficTotals(totals);
    }
    setTrafficBusy(false);

    return { totals, data };
  };

  const retrieveStats = async (domain: string) => {
    let trafficSum = 0;

    const { data, totals } = await retrieveTotals(domain);
    const paidTraffc = totals?.trafficType?.paid || 0;

    if (totals) {
      trafficSum = paidTraffc + (totals.trafficType?.organic || 0);

      if (trafficSum === 0) {
        onTrafficAbsent?.();
        setShowPaidTrafficROI?.(true);
      } else if (
        totals.trafficType &&
        !totals.trafficType?.usBasedTraffic &&
        trafficSum > 0
      ) {
        onNonUSTraffic?.();
      }

      if (paidTraffc > 0) {
        setShowPaidTrafficROI?.(true);
      }
    }

    if (trafficSum > TRAFFIC_SUM_TRESHOLD) {
      let monthly;
      try {
        setTrafficBusy(true);
        monthly = await retriveMonthlyByDomain(domain, data?.IPv4);
        setTrafficBusy(false);
      } catch (e) {}
      if (monthly) {
        setTrafficMonthly(monthly);
      }
    }

    const competitors = await retriveCompetitorsByDomain(domain);
    setCompetitors(competitors);

    const topLandings = await retriveTopLandingsByDomain(domain);
    setTopLiandings(topLandings);

    const websiteSummary = await retriveSummaryByDomain(domain);
    setWebsiteSummary(websiteSummary);

    setTrafficLoaded(true);
  };

  return {
    retrieveTotals,
    retrieveStats,
  };
};
